<script setup>
import { useI18n } from 'vue-i18n'
import { useMainStore } from '@/stores/main'

/**
 * The "?" next to a rating that is still settling.
 *
 * A driver in their first races has a rating built on too few results to be their level yet, and
 * while that is true the rating of whoever races them moves less too (see doc/races_ranking.md).
 *
 * The threshold is a server rule (config/ranking.php) and is not repeated here: it arrives with the
 * bootstrap and this component only prints it.
 */
const { t } = useI18n()
const store = useMainStore()
</script>

<template>
  <v-tooltip location="top" max-width="320">
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        size="16"
        color="medium-emphasis"
        class="ms-1"
        tabindex="0"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    {{ t('standings.provisional', { races: store.provisionalRaces }) }}
  </v-tooltip>
</template>
